
import { Discipline } from './types';

export const music: Discipline = {
  id: 'music',
  name: 'Music',
  courses: [
    {
      id: 'music101',
      title: 'Listening to Music',
      instructor: 'Craig Wright',
      link: 'https://www.youtube.com/playlist?list=PLh9mgdi4rNezhx8YiGIV8I22ICSuzslja',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=5_yOVARO2Oc&list=PLh9mgdi4rNezhx8YiGIV8I22ICSuzslja'
    }
  ]
};
